import React from 'react';
import { Route, Switch, useLocation, useRouteMatch } from 'react-router-dom';

import Hosting from 'containers/Hosting';
import ManageTestDataPage from 'containers/Hosting/ManageTestDataPage';
import ProjectForm from 'containers/Hosting/ProjectForm';
import TestCaseForm from 'containers/Hosting/TestCaseForm';
import GlobalFields from 'containers/GlobalFields';

/**
 * HostingKeepAliveRoutes
 *
 * Keeps the main Hosting screen mounted while navigating to nested routes
 * like Add/Edit Project and Global Fields under `/hosting/:category/*`.
 *
 * This prevents re-fetching projects/test cases when the user navigates back
 * to the Hosting list, because the `Hosting` component is not unmounted.
 *
 * @returns {JSX.Element}
 */
const HostingKeepAliveRoutes = () => {
  const location = useLocation();
  const match = useRouteMatch('/hosting/:category');

  // Show Hosting UI only on the base route, but keep it mounted always.
  const showHosting = location.pathname === match?.url;

  return (
    <>
      <div style={{ display: showHosting ? 'block' : 'none' }}>
        <Hosting />
      </div>

      <Switch>
        <Route
          exact
          path="/hosting/:category/manage-test-data/:projectname"
          component={ManageTestDataPage}
        />
        <Route
          exact
          path="/hosting/:category/add-project"
          render={(props) => <ProjectForm {...props} mode="create" />}
        />
        <Route
          exact
          path="/hosting/:category/edit-project/:projectname"
          render={(props) => <ProjectForm {...props} mode="edit" />}
        />
        <Route
          exact
          path="/hosting/:category/add-test-case/:projectname"
          render={(props) => <TestCaseForm {...props} mode="create" />}
        />
        <Route
          exact
          path="/hosting/:category/edit-test-case/:projectname/:testcasename"
          render={(props) => <TestCaseForm {...props} mode="edit" />}
        />
        <Route exact path="/hosting/:category/global-fields" component={GlobalFields} />
      </Switch>
    </>
  );
};

export default HostingKeepAliveRoutes;

